"use strict";

var _interopRequireDefault = require("/home/zklink/web/zklink-explorer-web-build/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
require("core-js/modules/es7.object.get-own-property-descriptors");
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.object.keys");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("/home/zklink/web/zklink-explorer-web-build/node_modules/@babel/runtime-corejs2/helpers/defineProperty.js"));
var _vuex = require("vuex");
var _variables2 = _interopRequireDefault(require("@/styles/variables.scss"));
var _config = require("@/config");
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var _default = {
  data: function data() {
    return {
      menuList: [{
        label: 'Overview',
        name: 'dashboard',
        path: '/dashboard',
        icon: 'dashboard'
      },
      // { label: 'Tokens', name: 'tokens', path: '/tokens', icon: 'tokens', },
      // { label: 'Pairs', name: 'pairs', path: '/pairs', icon: 'pairs', },
      {
        label: 'Transactions',
        name: 'transactions',
        path: '/transactions',
        icon: 'transactions'
      }, {
        label: 'Blocks',
        name: 'blocks',
        path: '/blocks',
        icon: 'blocks'
      }
      // { label: 'Accounts', name: 'accounts', path: '/accounts', icon: 'accounts', },
      ],

      selectLink: _config.CHANGE_LINK,
      selectLinkOptions: [{
        label: 'mainnet',
        value: 'https://scan.zk.link/'
      }, {
        label: 'testnet',
        value: 'https://test-scan.zk.link/'
      }]
    };
  },
  computed: _objectSpread(_objectSpread({}, (0, _vuex.mapGetters)(['permission_routes', 'sidebar'])), {}, {
    activeMenu: function activeMenu() {
      var route = this.$route;
      var meta = route.meta,
        path = route.path;
      // if set path, the sidebar will highlight the path you set
      if (meta.activeMenu) {
        return meta.activeMenu;
      }
      return path;
    },
    showLogo: function showLogo() {
      return this.$store.state.settings.sidebarLogo;
    },
    variables: function variables() {
      return _variables2.default;
    },
    isCollapse: function isCollapse() {
      return !this.sidebar.opened;
    }
  }),
  methods: {
    handleClickOutside: function handleClickOutside() {
      this.$store.dispatch('app/closeSideBar', {
        withoutAnimation: false
      });
    },
    selectHandler: function selectHandler(type) {
      this.selectLink = type;
    }
  }
};
exports.default = _default;